import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuth, reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import useSuperUserPermission from '../hooks/useSuperUserPermission';

const CreateSuperUser = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [superUserPassword, setSuperUserPassword] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [message, setMessage] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');

  const auth = getAuth();
  const { canCreateSuperUser, loading } = useSuperUserPermission();

  useEffect(() => {
    if (auth.currentUser) {
      setEmail(auth.currentUser.email);
      setUsername(auth.currentUser.displayName || '');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (superUserPassword === secretKey) {
      setMessage('SuperUser password and Secret Key must be different');
      return;
    }
    if (username === email) {
      setMessage('Username cannot be the same as your email');
      return;
    }
    if (!canCreateSuperUser) {
      setMessage('You do not have permission to create a SuperUser');
      return;
    }
    try {
      // Reauthenticate the user
      const credential = EmailAuthProvider.credential(auth.currentUser.email, currentPassword);
      await reauthenticateWithCredential(auth.currentUser, credential);

      // const response = await axios.post('http://localhost:4000/api/superuser/create', {
      const response = await axios.post(process.env.REACT_APP_API_EXTENDED_NEURO_URL + '/superuser/create', {
        username,
        email,
        superUserPassword,
        secretKey
      }, {
        headers: {
          'Authorization': `Bearer ${await auth.currentUser.getIdToken()}`
        }
      });
      setMessage(response.data.message);
    } catch (error) {
      setMessage(error.response?.data?.message || 'An error occurred');
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!canCreateSuperUser) {
    return <div>You do not have permission to create a SuperUser.</div>;
  }

  return (
    <div className="max-w-md mx-auto mt-10">
      <h2 className="text-2xl font-bold mb-5">Create SuperUser</h2>
      <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
        <div style={{ display: 'none' }}>
          <input type="text" id="username_hidden" name="username" autoComplete="username" />
        </div>
        <div>
          <label htmlFor="username" className="block mb-1">Username</label>
          <input
            type="text"
            id="username"
            name="username_custom"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-3 py-2 border rounded"
            required
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            data-lpignore="true"
            data-form-type="other"
          />
        </div>
        <div>
          <label htmlFor="email" className="block mb-1">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            readOnly
            className="w-full px-3 py-2 border rounded bg-gray-100"
          />
        </div>
        <div>
          <label htmlFor="currentPassword" className="block mb-1">Current Password</label>
          <input
            type="password"
            id="currentPassword"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="w-full px-3 py-2 border rounded"
            required
            autoComplete="current-password"
          />
        </div>
        <div>
          <label htmlFor="superUserPassword" className="block mb-1">SuperUser Password</label>
          <input
            type="password"
            id="superUserPassword"
            name="superUserPassword"
            value={superUserPassword}
            onChange={(e) => setSuperUserPassword(e.target.value)}
            className="w-full px-3 py-2 border rounded"
            required
            autoComplete="new-password"
          />
        </div>
        <div>
          <label htmlFor="secretKey" className="block mb-1">Secret Key</label>
          <input
            type="password"
            id="secretKey"
            name="secretKey"
            value={secretKey}
            onChange={(e) => setSecretKey(e.target.value)}
            className="w-full px-3 py-2 border rounded"
            required
            autoComplete="new-password"
          />
        </div>
        <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600">
          Create SuperUser
        </button>
      </form>
      {message && <p className="mt-4 text-center">{message}</p>}
    </div>
  );
};

export default CreateSuperUser;
